<template>
  <CoursesEnciteItem
    :pageTitle="'Online Courses CMMC Level 2'"
    :courseTitle="'CMMC Level 2'"
    :courseItems="items"
    :informationCardColor="'#00AFF7'"
    :informationCardTextColor="'#001426'"
  />
</template>
<script>
import CoursesEnciteItem from "./courses-encite-item.vue";
import { enciteCMMCLevel2Courses } from "../utils/coursesEnciteData";

export default {
  name: "encite-courses",
  components: {
    CoursesEnciteItem,
  },
  props: {
    query: String,
  },
  data() {
    return {
      items: enciteCMMCLevel2Courses,
    }
  },
}
</script>